<style scoped>

  .text-editor {
    height: 200px;
  }

</style>

<template>
  
  <div :id="'text-editor-container-' + _uid" class="text-editor">
  </div>

</template>  

<script>

  export default {

    name: "TextEditor",

    data() {
      return {
        editor: null,
      }
    },

    props: {
      placeholder: { type: String, default: "" },
      readOnly: { type: Boolean, default: false },
      contents: { type: String },
    },
    
    mounted() {

      let options = {
        theme: "snow",
        placeholder: this.placeholder,
        readOnly: this.readOnly,
        modules: { toolbar: [ ["bold", "italic", "underline"] ] },
      }

      if (this.readOnly)
        options.modules.toolbar = false

      this.editor = new Quill("#text-editor-container-" + this._uid, options)
      
      if (this.contents)
        this.setContents(this.contents)
    },

    methods: {

      getText() {
        return this.editor.getText()
      },

      getContents(options) {
        
        let data = null
        let contents = this.editor.getContents()

        if (options && options.toString) {
          data = JSON.stringify(contents)
        } else {
          data = this.$cloneObject(contents)
        }  

        return data
      },

      setContents(data) {

        let contents = null

        if (typeof data == "string") {
          contents = JSON.parse(data)
        } else {
          contents = this.$cloneObject(data)
        }           

        this.editor.setContents(contents)
      },

      addContents(data) {
        
        let newContents = null

        if (typeof data == "string") {
          newContents = JSON.parse(data)
        } else {
          newContents = this.$cloneObject(data)
        }

        let contents = this.getContents()

        if (this.isEmpty())
          this.clear()        

        newContents.ops.forEach((line) => contents.ops.push(line))

        this.setContents(contents)
      },

      clear() {
        this.editor.setContents([])          
      },

      isEmpty() {
        
        const cleanText = this.$replaceAll(this.getText(), "\n", "")

        return !cleanText
      },

    },
  }

</script>